import Base from '@studiometa/js-toolkit';
import Cookies from 'js-cookie';
import { isDev } from '../config';

/**
 * ProfilSelector class.
 *
 * BackEnd implementation of the AJAX Form:
 * @see /modules/custom/studiometa/modules/studiometa_profile_manager/src/Form/ProfileSelectorModalForm.php
 *
 * Endpoint route:
 * @see /modules/custom/studiometa/modules/studiometa_profile_manager/studiometa_profile_manager.routing.yml
 */
class ProfileSelector extends Base {
  /**
   * App configuration.
   * @return {Object}
   */
  get config() {
    return {
      name: 'ProfileSelector',
      log: isDev(),
      words: {},
      legend: null,
    };
  }

  /**
   * Get Current User Profile
   *
   * @return {String} Current User Profile from Session Cookies
   */
  get currentProfile() {
    return Cookies.get('current_profile');
  }

  /**
   * Set Current User Profile
   *
   * @param {string} value New profile value
   */
  set currentProfile(value) {
    Cookies.set('current_profile', value);
  }

  /**
   * Mounted
   */
  mounted() {
    if (this.currentProfile) {
      if (isDev()) {
        // eslint-disable-next-line no-console
        console.info(`Current User has the profile : ${this.currentProfile}`);
      }
    }
  }

  /**
   * Change legend on input click
   * @param  {Object} element
   * @return {void}
   */
  inputClick(e) {
    const key = String(e.target.getAttribute('value'));
    this.legend.className = '';
    this.legend.classList.add(key);
    this.legend.innerHTML = String(this.words[key]);
  }
}

export default ProfileSelector;
